export default "__VITE_ASSET__BaMHd5dK__";